function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
export function AdoptionTracking({
  width = 25,
  height = 25,
  ...props
}) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: width,
    height: height,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 1.875C6.641 1.875 1.875 6.641 1.875 12.5S6.641 23.125 12.5 23.125 23.125 18.359 23.125 12.5 18.359 1.875 12.5 1.875zM12.5 25C5.607 25 0 19.392 0 12.5 0 5.607 5.607 0 12.5 0 19.392 0 25 5.607 25 12.5 25 19.392 19.392 25 12.5 25z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.789 17.115a.944.944 0 01-.48-.13l-4.713-2.812a.943.943 0 01-.457-.806v-6.06a.938.938 0 011.875 0v5.527l4.256 2.538a.94.94 0 01-.481 1.743z",
    fill: "#000"
  }));
}
//# sourceMappingURL=AdoptionTracking.js.map